import React, {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {PAContext} from "../../Services/PAContext";


import {CardMedia, Checkbox, Chip, ListItem, Menu, MenuItem, MenuList, Paper} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {cancelChipStyle} from "../../components/ButtonStyle/Cancel";
import Rating from '@mui/material/Rating';
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import _ from "lodash";
import './planningPageStyle.css';
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Idea from "../../MasterEventObjects/Idea";
import Meal from "../../MasterEventObjects/Meal";
import PALocation from "../../MasterEventObjects/Location";
import Lodging from "../../MasterEventObjects/Lodging";
import {updateChipStyle} from "../../components/ButtonStyle/Update";
import Activity from "../../MasterEventObjects/Activity";
import usePA_GlobalStore from "../../Services/ZustandGlobalStore";
import {createTimeTableForLodging} from "../../components/Helpers/EventTimeTableConversion";




function GoogleMapMobile(props) {

    const navigate = useNavigate();


    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorLayersEl, setAnchorLayersEl] = useState(null);

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, ConciergeMapActions, authenticated } = dataArray;

    const zoomTimeoutRef = useRef(null);
    const [isInitialLoad, setIsInitialLoad] = useState(false);
    const isClearingRef = useRef(false);

    const [zoomInOnLocation, setZoomInOnLocation] = useState(props.zoomInOnLocation);

    const [viewPlaceInfoPlace, setViewPlaceInfoPlace] = useState(null);
    const [viewPlaceInfoWindow, setViewPlaceInfoWindow] = useState(false);

    const [mapMarkerLayers, setMapMarkerLayers] = useState([]);
    const [mapMarkerLayersCount, setMapMarkerLayersCount] = useState(0);


    const _default_map_options = {
        mapId: "6c79697cd5555167",
        center: {
            lat: 35.5951,
            lng: -82.5515,
        },
        zoom: 10,
        mapTypeControl: false,
        fullscreenControl: false
    }

    useEffect(() => {
        console.log("%%%%%%%%%%%%%% props._global_map_ref triggered");
        if (!props._global_map_ref) return;

        const initMapLogic = async () => {
            // 1. Load the necessary libraries using the new pattern
            const { Map } = await window.google.maps.importLibrary("maps");
            const { Place } = await window.google.maps.importLibrary("places");
            const { Geocoder } = await window.google.maps.importLibrary("geocoding");

            let _planningLocations = usePA_GlobalStore.getState().PA_GlobalObject.Planning?.locations;
            let mapOptions = _default_map_options;

            if (_planningLocations?.length > 0) {
                mapOptions = {
                    mapId: "6c79697cd5555167",
                    center: {
                        lat: _planningLocations[0].latitude,
                        lng: _planningLocations[0].longitude,
                    },
                    zoom: 10,
                    mapTypeControl: false,
                    fullscreenControl: false
                };
            }

            // Initialize Map
            props._global_map_ref.current = new Map(
                document.getElementById("global_google_map_holder"),
                mapOptions
            );

            const map = props._global_map_ref.current;

            map.addListener('click', async (event) => {
                // event.stop() prevents the default Google "POI" card from appearing
                console.log("An EVENT : ", event);

                if (event.placeId) {
                    event.stop();
                    await handlePlaceClick(event.placeId);
                } else {
                    await handleResidenceClick(event.latLng);
                }
            });

            // --- NEW MODERN HANDLERS ---

            async function handlePlaceClick(placeId) {
                console.log("---- handlePlaceClick  : ", placeId);

                const place = new Place({ id: placeId });

                // This replaces PlacesService.getDetails
                // IMPORTANT: Specify only the fields you need to save money/performance
                await place.fetchFields({
                    fields: [
                        'displayName', 'formattedAddress', 'location', 'addressComponents',
                        'id', 'photos', 'websiteURI', 'internationalPhoneNumber',
                        'openingHours', 'priceLevel', 'rating', 'userRatingCount', 'types'
                    ]
                });

                console.log("the PLace  : ", place.toJSON());
                setViewPlaceInfoPlace(place);
                setViewPlaceInfoWindow(true);

            }

            async function handleResidenceClick(latLng) {

                console.log("---- handleResidenceClick  : ", latLng);

                const geocoder = new Geocoder();
                const { results } = await geocoder.geocode({ location: latLng });

                console.log("---- results  : ", results);

                if (results && results.length > 0) {
                    const place = results[0];

                    setViewPlaceInfoPlace(place);
                    setViewPlaceInfoWindow(true);

                }
            }

            console.log("Setting all layer markers visibility to true ..............");
            setMapMarkerLayers((prev) =>
                prev.map(layer => ({
                    ...layer,
                    visible: true
                }))
            );

        };

        initMapLogic().catch(console.error);

    }, [props._global_map_ref]);

    useEffect(() => {
        console.log("props.searchingForLocation : {"+props.searchingForLocation+"}");

        if (Object.keys(props.searchingForLocation)?.length > 0){
            //do the search
            const request = {
                query: props.searchingForLocation,
            };

            console.log("props.searchingForLocation request : "+JSON.stringify(request));

            const _global_map_service = new window.google.maps.places.PlacesService(props._global_map_ref.current);
            _global_map_service.textSearch(request, (results, status) => {

                console.log("textSearch status : "+status);

                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    // Handle the search results (e.g. display them on a map or list)

                    console.log("number of results : "+results.length);

                    for (const _item of results) {

                        console.log("The returned place : " + JSON.stringify(_item, null, '\t'));
                        const _geometry = _item.geometry;

                        const icon_for_event_activity = document.createElement("div");
                        icon_for_event_activity.innerHTML = '<i class="icon-list-heart google-maps-advanced-marker-glyph-icon"></i>';

                        const pinViewCustomIdea = new window.google.maps.marker.PinView({
                            background: "#f09637",
                            borderColor: "#428ce2",
                            glyphColor: "#FFFFFF",
                            glyph: icon_for_event_activity,
                        });

                        new window.google.maps.marker.AdvancedMarkerView({
                            map: props._global_map_ref.current,
                            position: _geometry.location,
                            content: pinViewCustomIdea.element,
                            title: _item.name,
                        });

                        props._global_map_ref.current.setCenter(_geometry.location);

                    }

//                adjustGlobalMapMarkersBoundsZoom();

                } else {
                    console.log("no results for ")
                }
            });

        }


    }, [props.searchingForLocation]);

    useEffect(() => {
        console.log("Move to area : "+JSON.stringify(props.zoomInOnLocation, null, '\t'));

        console.log("latitude : "+props.zoomInOnLocation['latitude']);
        console.log("longitude : "+props.zoomInOnLocation['longitude']);

        if (Object.keys(props.zoomInOnLocation).length !== 0){
            try {

                props._global_map_ref.current.setCenter(
                    new window.google.maps.LatLng(props.zoomInOnLocation['latitude'], props.zoomInOnLocation['longitude'])
                );
                setZoomInOnLocation(new window.google.maps.LatLng(props.zoomInOnLocation['latitude'], props.zoomInOnLocation['longitude']));

                //add a Marker at the location

//                new window.google.maps.marker.AdvancedMarkerView({
//                    map: props._global_map_ref.current,
//                    position: new window.google.maps.LatLng(props.zoomInOnLocation['latitude'], props.zoomInOnLocation['longitude']),
//                });

            } catch (e){
                console.log("Move to error : "+e);
            }
        }

    }, [props.zoomInOnLocation]);

    useEffect(() => {
        console.log("Another ConciergeMapActions was triggered : "+ConciergeMapActions.length);

        for (let i = 0; i < ConciergeMapActions.length; i++) {
            const mapAction = ConciergeMapActions[i];

            console.log(JSON.stringify(mapAction, null, '\t'));

            if (mapAction.action === "planningConciergeMapSuggestionChangeResults"){

                if (mapAction.suggestion === "Outdoor Activities"){
                    for (const _item of mapAction.response_message_array){
                        console.log("the Outdoor Idea item : "+_item.business_name);
                        //put a pin on the map and number it

                        const request = {
                            query: _item.business_name +" located in "+props.searchingForLocation,
                            location: props._global_map_ref.current.getCenter(),
                            radius: 1500,
                            types: _item.activity
                        };

                        console.log("search request : "+JSON.stringify(request));

                        const _global_map_service = new window.google.maps.places.PlacesService(props._global_map_ref.current);
                        _global_map_service.textSearch(request, (results, status) => {

                            console.log("textSearch status : "+status);

                            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                                // Handle the search results (e.g. display them on a map or list)

                                const icon_for_event_activity = document.createElement("div");
                                icon_for_event_activity.innerHTML = '<i class="icon-list-heart google-maps-advanced-marker-glyph-icon"></i>';

                                const pinViewCustomIdea = new window.google.maps.marker.PinView({
                                    background: "#f09637",
                                    borderColor: "#428ce2",
                                    glyphColor: "#FFFFFF",
                                    glyph: icon_for_event_activity,
                                    scale: 1.5
                                });

                                for (const _item of results) {

                                    console.log("The returned place : " + JSON.stringify(_item, null, '\t'));
                                    const _geometry = _item.geometry;

                                    new window.google.maps.marker.AdvancedMarkerView({
                                        map: props._global_map_ref.current,
                                        position: _geometry.location,
                                        content: pinViewCustomIdea.element,
                                        title: _item.name,
                                    });

                                }

                                //rezoom the map
//                                adjustGlobalMapMarkersBoundsZoom();

                            } else {
                                console.log("no results for ")
                            }
                        });
                    }
                }

            }

            //remove the one item we just processed
            ConciergeMapActions.splice(i, 1);

        }

    }, [ConciergeMapActions]);


    const MEAL_RADIUS = 0.00005; // ~5.5 meters
    const ACTIVITY_RADIUS = 0.00006; // ~6.6 meters
    const LODGING_RADIUS = 0.00007; // ~7.7 meters
    const IDEA_RADIUS = 0.00008; // ~8.8 meters

    const CATEGORY_RADIUSES = {
        MEAL: 0.00005,           // ~5.5 meters
        ACTIVITY: 0.00006,       // ~6.6 meters
        LODGING: 0.00007,        // ~7.7 meters
        IDEA: 0.00008,           // ~8.8 meters[cite: 5]
        SHOPPING: 0.00009,       // ~9.9 meters
        SUPPLIES: 0.00009,       // ~9.9 meters
        TRANSPORTATION: 0.00010, // ~11 meters
    };

    const globalMarkerMap = new Map();

    function getCircularOffsetPosition(basePosition, index, totalMarkers, radius) {
        const angle = (2 * Math.PI * index) / totalMarkers; // Angle for each marker
        const latOffset = radius * Math.cos(angle); // X-coordinate offset
        const lngOffset = radius * Math.sin(angle); // Y-coordinate offset

        return {
            lat: basePosition.lat + latOffset,
            lng: basePosition.lng + lngOffset,
        };
    }



    useEffect(() => {
        // Only zoom if we actually have markers and are in the initial load phase
        if (isInitialLoad && mapMarkerLayersCount > 0) {

            // Clear any previous zoom requests
            if (zoomTimeoutRef.current) clearTimeout(zoomTimeoutRef.current);

            // Wait 800ms of "silence" before calculating the final view
            zoomTimeoutRef.current = setTimeout(() => {
//                adjustGlobalMapMarkersBoundsZoom1();
//                setIsInitialLoad(false);
            }, 800);
        }

        return () => clearTimeout(zoomTimeoutRef.current);
    }, [mapMarkerLayersCount, isInitialLoad]);


    useEffect(() => {

        console.log("PA_GlobalObject.Planning.lodging triggered");

        const currentLodging = PA_GlobalObject?.Planning?.lodging || [];
        const currentMapLodgingLayer = mapMarkerLayers.find(layer => layer.name === "Lodging");

        const existingPlaceIds = currentMapLodgingLayer
            ? currentMapLodgingLayer.markers.map(marker => marker.google_place_id)
            : [];

        const lodgingPlaceIds = currentLodging.map(l => l.location?.google_place_id).filter(Boolean);

        // --- 1. UPDATE SIDEBAR DOTS ---
        const activeLodgingKeys = {};
        currentLodging.forEach(item => {
            const tt = item.time_table;
            if (!tt) return;

            // Check the dates array inside this item's time_table
            if (tt.dates && Array.isArray(tt.dates)) {
                tt.dates.forEach(dObj => {
                    if (dObj.date) activeLodgingKeys[dObj.date] = true;
                });
            }

            // Check the days array inside this item's time_table
            if (tt.days && Array.isArray(tt.days)) {
                tt.days.forEach(dObj => {
                    // Find the key that starts with "day" (e.g., "day 1")
                    const dayKey = Object.keys(dObj).find(k => k.toLowerCase().startsWith('day'));
                    if (dayKey) activeLodgingKeys[dayKey] = true;
                });
            }
        });

        // --- 2. CLEANUP OLD MARKERS ---
        existingPlaceIds.forEach(placeId => {
            if (!lodgingPlaceIds.includes(placeId)) {
                removeMapMarkerLayerItem("Lodging", placeId);
            }
        });

        // --- 3. UPDATE EXISTING TITLES ---
        if (currentMapLodgingLayer) {
            currentLodging.forEach(lodgingItem => {
                const placeId = lodgingItem.location?.google_place_id;
                if (!placeId) return;

                const existingMarker = currentMapLodgingLayer.markers.find(m => m.google_place_id === placeId);
                const updatedTitle = lodgingItem.location?.name || lodgingItem.name;

                if (existingMarker && existingMarker.title !== updatedTitle) {
                    existingMarker.title = updatedTitle;
                    if (existingMarker.marker) existingMarker.marker.title = updatedTitle;
                }
            });
        }

        // --- 4. ADD NEW MARKERS ---
        if (currentLodging.length > 0) {
            const _shade_of_black = getRandomShadeOfBlack();

            currentLodging.forEach((lodgingItem, index) => {
                const placeId = lodgingItem.location?.google_place_id;
                if (!placeId || existingPlaceIds.includes(placeId)) return;

                const basePosition = {
                    lat: lodgingItem.location.latitude,
                    lng: lodgingItem.location.longitude,
                };

                const adjustedPosition = getCircularOffsetPosition(
                    basePosition,
                    index,
                    currentLodging.length,
                    LODGING_RADIUS
                );

                const markerContent = document.createElement("div");
                markerContent.className = "search-results planning-google-map-marker-search-results-item";
                markerContent.style.backgroundColor = _shade_of_black;
                markerContent.style.color = "white";
                markerContent.style.pointerEvents = "auto";
                markerContent.style.cursor = "pointer";
                markerContent.innerHTML = `<i class="planning-google-map-marker-layer-item-icon icon-bed" />`;

                // Modernized async Place selection handler
                const handleMarkerSelect = async (e) => {
                    if (e && e.stopPropagation) e.stopPropagation();

                    const map = props._global_map_ref.current;
                    if (!map) return;

                    map.setZoom(15);
                    map.setCenter(adjustedPosition);

                    try {
                        // Modern Places API (New) Class
                        const place = new window.google.maps.places.Place({ id: placeId });

                        await place.fetchFields({
                            fields: [
                                'displayName',
                                'formattedAddress',
                                'location',
                                'photos',
                                'rating',
                                'userRatingCount',
                                'websiteURI',
                                'nationalPhoneNumber'
                            ]
                        });

                        setViewPlaceInfoPlace(place);
                        setViewPlaceInfoWindow(true);
                    } catch (err) {
                        console.error("Error fetching lodging details with Places API (New):", err);
                    }
                };

                // Desktop click listener on DOM node
                markerContent.addEventListener("click", handleMarkerSelect);

                // Mobile touch listener for immediate tap response
                markerContent.addEventListener("touchend", (e) => {
                    e.preventDefault();
                    handleMarkerSelect(e);
                });

                const newMarker = new window.google.maps.marker.AdvancedMarkerView({
                    map: props._global_map_ref.current,
                    position: adjustedPosition,
                    content: markerContent,
                    title: lodgingItem.location?.name || lodgingItem.name,
                });

                // Fallback Google Maps click listener
                newMarker.addListener("click", handleMarkerSelect);

                addMarkerToLayer("Lodging", {
                    _id: lodgingItem.id,
                    temp_id: lodgingItem.temp_id,
                    title: lodgingItem.location?.name || lodgingItem.name,
                    google_place_id: placeId,
                    marker: newMarker,
                    time_table: lodgingItem.time_table
                });
            });
        } else {
            removeMapMarkerLayer("Lodging");
        }
    }, [PA_GlobalObject.Planning.lodging]);

    useEffect(() => {

        console.log("PA_GlobalObject.Planning.activities triggered");

        const currentActivities = PA_GlobalObject?.Planning?.activities || [];
        // Note: Ensuring the layer name matches your state "Activit"
        const currentMapActivitiesLayer = mapMarkerLayers.find(layer => layer.name === "Activit");

        // --- 1. UPDATE SIDEBAR DOTS (SUPPORT MULTI-DATE SPAN) ---
        const activeActivityKeys = {};
        currentActivities.forEach(item => {
            const tt = item.time_table;
            if (!tt) return;

            // Scan the nested dates array
            if (tt.dates && Array.isArray(tt.dates)) {
                tt.dates.forEach(dObj => {
                    if (dObj.date) activeActivityKeys[dObj.date] = true;
                });
            }

            // Scan the nested days array
            if (tt.days && Array.isArray(tt.days)) {
                tt.days.forEach(dObj => {
                    // Find the dynamic key (e.g., "day 1", "day 4")
                    const dayKey = Object.keys(dObj).find(k => k.toLowerCase().startsWith('day'));
                    if (dayKey) activeActivityKeys[dayKey] = true;
                });
            }
        });

        // --- 2. MARKER LIFECYCLE MANAGEMENT ---
        const existingPlaceIds = currentMapActivitiesLayer
            ? currentMapActivitiesLayer.markers.map(m => m.google_place_id)
            : [];
        const activityPlaceIds = currentActivities.map(a => a.location?.google_place_id).filter(Boolean);

        // 🧹 Remove old markers
        existingPlaceIds.forEach(placeId => {
            if (!activityPlaceIds.includes(placeId)) {
                removeMapMarkerLayerItem("Activit", placeId);
            }
        });

        // 🔄 Update existing titles
        if (currentMapActivitiesLayer) {
            currentActivities.forEach(activityItem => {
                const placeId = activityItem.location?.google_place_id;
                if (!placeId) return;

                const existingMarker = currentMapActivitiesLayer.markers.find(m => m.google_place_id === placeId);
                const updatedTitle = activityItem.location?.name || activityItem.title;

                if (existingMarker && existingMarker.title !== updatedTitle) {
                    existingMarker.title = updatedTitle;
                    if (existingMarker.marker) existingMarker.marker.title = updatedTitle;
                }
            });
        }

        // 🎯 Add new markers
        if (currentActivities.length > 0) {
            const _shade_of_black = getRandomShadeOfBlack();

            currentActivities.forEach((activityItem, index) => {
                const placeId = activityItem.location?.google_place_id;
                if (!placeId || existingPlaceIds.includes(placeId)) return;

                const pos = { lat: activityItem.location.latitude, lng: activityItem.location.longitude };
                const adjustedPosition = getCircularOffsetPosition(
                    pos,
                    index,
                    currentActivities.length,
                    ACTIVITY_RADIUS
                );

                const markerContent = document.createElement("div");
                markerContent.className = "search-results planning-google-map-marker-search-results-item";
                markerContent.style.backgroundColor = _shade_of_black;
                markerContent.style.color = "white";
                markerContent.style.pointerEvents = "auto";
                markerContent.style.cursor = "pointer";
                markerContent.innerHTML = `<i class="planning-google-map-marker-layer-item-icon icon-list-heart" />`;

                // Modernized async Place selection handler
                const handleMarkerSelect = async (e) => {
                    if (e && e.stopPropagation) e.stopPropagation();

                    const map = props._global_map_ref.current;
                    if (!map) return;

                    map.setZoom(15);
                    map.setCenter(adjustedPosition);

                    try {
                        // Modern Places API (New) Class
                        const place = new window.google.maps.places.Place({ id: placeId });

                        await place.fetchFields({
                            fields: [
                                'displayName',
                                'formattedAddress',
                                'location',
                                'photos',
                                'rating',
                                'userRatingCount',
                                'websiteURI',
                                'nationalPhoneNumber'
                            ]
                        });

                        setViewPlaceInfoPlace(place);
                        setViewPlaceInfoWindow(true);
                    } catch (err) {
                        console.error("Error fetching activity details with Places API (New):", err);
                    }
                };

                // Desktop click listener on DOM node
                markerContent.addEventListener("click", handleMarkerSelect);

                // Mobile touch listener for immediate tap response
                markerContent.addEventListener("touchend", (e) => {
                    e.preventDefault();
                    handleMarkerSelect(e);
                });

                const newMarker = new window.google.maps.marker.AdvancedMarkerView({
                    map: props._global_map_ref.current,
                    position: adjustedPosition,
                    content: markerContent,
                    title: activityItem.location?.name || activityItem.title,
                });

                // Fallback Google Maps click listener
                newMarker.addListener("click", handleMarkerSelect);

                addMarkerToLayer("Activit", {
                    _id: activityItem.id,
                    temp_id: activityItem.temp_id,
                    title: activityItem.title,
                    google_place_id: placeId,
                    marker: newMarker,
                    time_table: activityItem.time_table
                });
            });
        } else {
            removeMapMarkerLayer("Activit");
        }
    }, [PA_GlobalObject.Planning.activities]);

    useEffect(() => {

        console.log("PA_GlobalObject.Planning.meals triggered");

        const currentMeals = PA_GlobalObject?.Planning?.meals || [];
        const currentMapMealsLayer = mapMarkerLayers.find(layer => layer.name === "Meal");

        // --- 1. UPDATE SIDEBAR DOTS (NESTED TIME_TABLE SCAN) ---
        const activeMealKeys = {};
        currentMeals.forEach(item => {
            const tt = item.time_table;
            if (!tt) return;

            // Scan nested dates array for date-based itineraries
            if (tt.dates && Array.isArray(tt.dates)) {
                tt.dates.forEach(dObj => {
                    if (dObj.date) activeMealKeys[dObj.date] = true;
                });
            }

            // Scan nested days array for generic "Day X" itineraries
            if (tt.days && Array.isArray(tt.days)) {
                tt.days.forEach(dObj => {
                    // Find dynamic keys like "day 1", "day 4", etc.
                    const dayKey = Object.keys(dObj).find(k => k.toLowerCase().startsWith('day'));
                    if (dayKey) activeMealKeys[dayKey] = true;
                });
            }
        });

        // --- 2. MARKER LIFECYCLE MANAGEMENT ---
        const existingPlaceIds = currentMapMealsLayer
            ? currentMapMealsLayer.markers.map(m => m.google_place_id)
            : [];
        const mealPlaceIds = currentMeals.map(m => m.location?.google_place_id).filter(Boolean);

        // 🧹 Remove markers that no longer exist
        existingPlaceIds.forEach(placeId => {
            if (!mealPlaceIds.includes(placeId)) {
                removeMapMarkerLayerItem("Meal", placeId);
            }
        });

        // 🔄 Update titles for existing markers
        if (currentMapMealsLayer) {
            currentMeals.forEach(mealItem => {
                const placeId = mealItem.location?.google_place_id;
                if (!placeId) return;

                const existingMarker = currentMapMealsLayer.markers.find(m => m.google_place_id === placeId);
                const mealTitle = mealItem.location?.name || mealItem.name;

                if (existingMarker && existingMarker.title !== mealTitle) {
                    existingMarker.title = mealTitle;
                    if (existingMarker.marker) existingMarker.marker.title = mealTitle;
                }
            });
        }

        // 🎯 Add new markers
        if (currentMeals.length > 0) {
            const _shade_of_black = getRandomShadeOfBlack();

            currentMeals.forEach((mealItem, index) => {
                const placeId = mealItem.location?.google_place_id;
                if (!placeId || existingPlaceIds.includes(placeId)) return;

                const pos = { lat: mealItem.location.latitude, lng: mealItem.location.longitude };
                const adjustedPosition = getCircularOffsetPosition(
                    pos,
                    index,
                    currentMeals.length,
                    MEAL_RADIUS
                );

                const markerContent = document.createElement("div");
                markerContent.className = "search-results planning-google-map-marker-search-results-item";
                markerContent.style.backgroundColor = _shade_of_black;
                markerContent.style.color = "white";
                markerContent.style.pointerEvents = "auto";
                markerContent.style.cursor = "pointer";
                markerContent.innerHTML = `<i class="planning-google-map-marker-layer-item-icon icon-fork-knife2" />`;

                // Modernized async Place selection handler
                const handleMarkerSelect = async (e) => {
                    if (e && e.stopPropagation) e.stopPropagation();

                    const map = props._global_map_ref.current;
                    if (!map) return;

                    map.setZoom(15);
                    map.setCenter(adjustedPosition);

                    try {
                        // Modern Places API (New) Class
                        const place = new window.google.maps.places.Place({ id: placeId });

                        await place.fetchFields({
                            fields: [
                                'displayName',
                                'formattedAddress',
                                'location',
                                'photos',
                                'rating',
                                'userRatingCount',
                                'websiteURI',
                                'nationalPhoneNumber'
                            ]
                        });

                        setViewPlaceInfoPlace(place);
                        setViewPlaceInfoWindow(true);
                    } catch (err) {
                        console.error("Error fetching meal details with Places API (New):", err);
                    }
                };

                // Desktop click listener on DOM node
                markerContent.addEventListener("click", handleMarkerSelect);

                // Mobile touch listener for immediate tap response
                markerContent.addEventListener("touchend", (e) => {
                    e.preventDefault();
                    handleMarkerSelect(e);
                });

                const newMarker = new window.google.maps.marker.AdvancedMarkerView({
                    map: props._global_map_ref.current,
                    position: adjustedPosition,
                    content: markerContent,
                    title: mealItem.location?.name || mealItem.name,
                });

                // Fallback Google Maps click listener
                newMarker.addListener("click", handleMarkerSelect);

                addMarkerToLayer("Meal", {
                    _id: mealItem.id,
                    temp_id: mealItem.temp_id,
                    title: mealItem.location?.name || mealItem.name,
                    google_place_id: placeId,
                    marker: newMarker,
                    time_table: mealItem.time_table
                });
            });
        } else {
            removeMapMarkerLayer("Meal");
        }

    }, [PA_GlobalObject.Planning.meals]);

    useEffect(() => {

        console.log("PA_GlobalObject.Planning.ideas triggered");

        const currentIdeas = PA_GlobalObject?.Planning?.ideas || usePA_GlobalStore.getState().PA_GlobalObject?.Planning?.ideas || [];
        const currentMapIdeasLayer = mapMarkerLayers.find(layer => layer.name === "Idea");

        const existingPlaceIds = currentMapIdeasLayer
            ? currentMapIdeasLayer.markers.map(marker => marker.google_place_id)
            : [];

        const ideaPlaceIds = currentIdeas
            ? currentIdeas.map(idea => idea.location?.google_place_id).filter(Boolean)
            : [];

        // 🧹 1. Remove markers from the map that no longer exist in ideas
        existingPlaceIds.forEach(placeId => {
            if (!ideaPlaceIds.includes(placeId)) {
                removeMapMarkerLayerItem("Idea", placeId);
            }
        });

        // 🔄 2. Update marker titles if idea name changed
        if (currentMapIdeasLayer) {
            currentIdeas.forEach(ideaItem => {
                const placeId = ideaItem.location?.google_place_id;
                if (!placeId) return;

                const existingMarker = currentMapIdeasLayer.markers.find(m => m.google_place_id === placeId);
                const ideaTitle = ideaItem.location?.name || ideaItem.title || ideaItem.name;

                if (existingMarker && existingMarker.title !== ideaTitle) {
                    console.log(`✏️ Updating marker title for ${placeId}`);
                    existingMarker.title = ideaTitle;
                    if (existingMarker.marker) {
                        existingMarker.marker.title = ideaTitle;
                    }
                }
            });
        }

        // 🎯 3. Add markers for new idea items not yet on the map
        if (currentIdeas && currentIdeas.length > 0) {
            const _shade_of_black = getRandomShadeOfBlack();

            currentIdeas.forEach((ideaItem, index) => {
                const placeId = ideaItem.location?.google_place_id;
                if (!placeId) return;

                const alreadyExists = existingPlaceIds.includes(placeId);
                if (alreadyExists) return; // Skip if marker already exists

                const basePosition = {
                    lat: ideaItem.location.latitude,
                    lng: ideaItem.location.longitude,
                };

                const adjustedPosition = getCircularOffsetPosition(
                    basePosition,
                    index,
                    currentIdeas.length,
                    IDEA_RADIUS
                );

                const markerContent = document.createElement("div");
                markerContent.className = "search-results planning-google-map-marker-search-results-item";
                markerContent.style.backgroundColor = _shade_of_black;
                markerContent.style.color = "white";
                markerContent.style.pointerEvents = "auto";
                markerContent.style.cursor = "pointer";
                markerContent.title = ideaItem.location?.name || ideaItem.title || ideaItem.name;
                markerContent.innerHTML = `<i class="planning-google-map-marker-layer-item-icon icon-lamp-bright" />`;

                // Modernized async Place selection handler
                const handleMarkerSelect = async (e) => {
                    if (e && e.stopPropagation) e.stopPropagation();

                    const map = props._global_map_ref.current;
                    if (!map) return;

                    console.log("!!!! clicked/tapped on " + (ideaItem.location?.name || ideaItem.title || ideaItem.name));
                    map.setZoom(15);
                    map.setCenter(adjustedPosition);

                    try {
                        // Modern Places API (New) Class
                        const place = new window.google.maps.places.Place({ id: placeId });

                        await place.fetchFields({
                            fields: [
                                'displayName',
                                'formattedAddress',
                                'location',
                                'photos',
                                'rating',
                                'userRatingCount',
                                'websiteURI',
                                'nationalPhoneNumber'
                            ]
                        });

                        setViewPlaceInfoPlace(place);
                        setViewPlaceInfoWindow(true);
                    } catch (err) {
                        console.error("Error fetching idea place details with Places API (New):", err);
                    }
                };

                // Desktop click listener on DOM node
                markerContent.addEventListener("click", handleMarkerSelect);

                // Mobile touch listener for immediate tap response
                markerContent.addEventListener("touchend", (e) => {
                    e.preventDefault();
                    handleMarkerSelect(e);
                });

                const newMarker = new window.google.maps.marker.AdvancedMarkerView({
                    map: props._global_map_ref.current,
                    position: adjustedPosition,
                    content: markerContent,
                    title: ideaItem.location?.name || ideaItem.title || ideaItem.name,
                });

                // Fallback Google Maps click listener
                newMarker.addListener("click", handleMarkerSelect);

                const newMarkerData = {
                    _id: ideaItem.id,
                    temp_id: ideaItem.temp_id,
                    title: ideaItem.title || ideaItem.location?.name,
                    google_place_id: placeId,
                    marker: newMarker,
                    time_table: ideaItem.time_table
                };

                addMarkerToLayer("Idea", newMarkerData);
            });
        } else {
            // No ideas, clear out the Ideas layer
            removeMapMarkerLayer("Idea");
        }

    }, [PA_GlobalObject.Planning.ideas]);

    useEffect(() => {
        const currentReceipts = usePA_GlobalStore.getState().PA_GlobalObject.Planning.receipts || [];

        // Configuration array defining receipt sections and their respective layer/icon settings
        const receiptCategories = [
            { section: "Shopping", layerName: "Shopping", icon: "icon-bag", radius: CATEGORY_RADIUSES?.SHOPPING || 0.00009 },
            { section: "Supplies", layerName: "Supplies", icon: "icon-basket", radius: CATEGORY_RADIUSES?.SUPPLIES || 0.00009 },
            { section: "Transportation", layerName: "Transportation", icon: "icon-gas-station", radius: CATEGORY_RADIUSES?.TRANSPORTATION || 0.00010 }
        ];

        receiptCategories.forEach(({ section, layerName, icon, radius }) => {
            // 1. Filter ALL items for this section
            const currentCategoryItems = currentReceipts.filter(receipt => receipt.section === section);
            const currentMapLayer = mapMarkerLayers.find(layer => layer.name === layerName);

            const existingPlaceIds = currentMapLayer
                ? currentMapLayer.markers.map(marker => marker.google_place_id)
                : [];

            const validPlaceIds = currentCategoryItems
                .map(item => item.location?.google_place_id)
                .filter(Boolean);

            // 🧹 2. Remove markers from map that no longer exist in global state
            existingPlaceIds.forEach(placeId => {
                if (!validPlaceIds.includes(placeId)) {
                    removeMapMarkerLayerItem(layerName, placeId);
                }
            });

            // 🔄 3. Update existing marker titles if location name or notes changed
            if (currentMapLayer) {
                currentCategoryItems.forEach(item => {
                    const placeId = item.location?.google_place_id;
                    if (!placeId) return;

                    const existingMarker = currentMapLayer.markers.find(m => m.google_place_id === placeId);
                    const updatedTitle = item.location?.name || item.title || item.notes;

                    if (existingMarker && existingMarker.title !== updatedTitle) {
                        console.log(`✏️ Updating marker title for ${placeId} in ${layerName}`);
                        existingMarker.title = updatedTitle;
                        if (existingMarker.marker) {
                            existingMarker.marker.title = updatedTitle;
                        }
                    }
                });
            }

            // 🎯 4. Add markers for new items not yet on the map
            if (currentCategoryItems.length > 0) {
                const _shade_of_black = getRandomShadeOfBlack();

                currentCategoryItems.forEach((item, index) => {
                    const placeId = item.location?.google_place_id;
                    if (!placeId) return;

                    const alreadyExists = existingPlaceIds.includes(placeId);
                    if (alreadyExists) return; // Skip if marker already exists

                    const basePosition = {
                        lat: item.location.latitude,
                        lng: item.location.longitude,
                    };

                    const adjustedPosition = getCircularOffsetPosition(
                        basePosition,
                        index,
                        currentCategoryItems.length,
                        radius
                    );

                    const markerContent = document.createElement("div");
                    markerContent.className = "search-results planning-google-map-marker-search-results-item";
                    markerContent.style.backgroundColor = _shade_of_black;
                    markerContent.style.color = "white";
                    markerContent.style.pointerEvents = "auto";
                    markerContent.style.cursor = "pointer";
                    markerContent.innerHTML = `<i class="planning-google-map-marker-layer-item-icon ${icon}" />`;

                    // Modernized Place click/tap handler (No PlacesService / Legacy API needed)
                    const handleMarkerSelect = async (e) => {
                        if (e && e.stopPropagation) e.stopPropagation();

                        const map = props._global_map_ref.current;
                        if (!map) return;

                        console.log("!!!! clicked/tapped on " + (item.location?.name || item.title));
                        map.setZoom(15);
                        map.setCenter(adjustedPosition);

                        try {
                            // 🚀 Modern Google Maps Places API (New) Class
                            const place = new window.google.maps.places.Place({ id: placeId });

                            // Request specific field values natively supported by Places API (New)
                            await place.fetchFields({
                                fields: [
                                    'displayName',
                                    'formattedAddress',
                                    'location',
                                    'photos',
                                    'rating',
                                    'userRatingCount',
                                    'websiteURI',
                                    'nationalPhoneNumber'
                                ]
                            });

                            setViewPlaceInfoPlace(place);
                            setViewPlaceInfoWindow(true);
                        } catch (err) {
                            console.error("Error fetching place details with Places API (New):", err);
                        }
                    };

                    // Desktop click listener on DOM node
                    markerContent.addEventListener("click", handleMarkerSelect);

                    // Mobile touch listener for immediate tap response
                    markerContent.addEventListener("touchend", (e) => {
                        e.preventDefault();
                        handleMarkerSelect(e);
                    });

                    const newMarker = new window.google.maps.marker.AdvancedMarkerView({
                        map: props._global_map_ref.current,
                        position: adjustedPosition,
                        content: markerContent,
                        title: item.location?.name || item.title || item.notes,
                    });

                    // Fallback Google Maps click listener
                    newMarker.addListener("click", handleMarkerSelect);

                    const newMarkerData = {
                        _id: item.id,
                        temp_id: item.temp_id,
                        title: item.title || item.location?.name,
                        google_place_id: placeId,
                        marker: newMarker,
                        time_table: item.time_table
                    };

                    addMarkerToLayer(layerName, newMarkerData);
                });
            } else {
                // No items found for this receipt section, clear out the layer
                removeMapMarkerLayer(layerName);
            }
        });

    }, [PA_GlobalObject.Planning.receipts]);


    useEffect(() => {
        console.log("98237459827345987234057", mapMarkerLayers);

        const currentMap = props._global_map_ref.current;
        if (!currentMap) return;

        mapMarkerLayers.forEach(layer => {
            console.log("working on layer : ", layer);
            // LAYER CHECK: Is the checkbox on the right UNCHECKED?
            const isLayerHidden = layer.visible === false;
            console.log("layer hidden: ", isLayerHidden);

            layer.markers.forEach(markerData => {
                console.log("working on layer marker: ", markerData.marker);

                if (!markerData.marker) return;

                // 1. If the whole category is hidden, hide the marker and move on.
                if (isLayerHidden) {
                    console.log("set layer marker map to null: ");
                    markerData.marker.map = null;
                    return;
                }
                console.log("set layer marker map to currentMap: ");
                markerData.marker.map = currentMap;
            });
        });

        // Re-fit the map to what's left
        adjustGlobalMapMarkersBoundsZoom1();

    }, [mapMarkerLayers]);


    const [expandedLayers, setExpandedLayers] = useState({}); // { 'LayerName': true }

    const handleButtonOpenLayersMenuClick = (event) => {
        setAnchorLayersEl(event.currentTarget);
    }
    const handleButtonLayersMenuClose = () => {
        setAnchorLayersEl(null);
    };

    const toggleLayerVisibility = (layerName) => {
        console.log("toggleLayerVisibility : " + layerName);

        setMapMarkerLayers((prev) =>
            prev.map(layer =>
                layer.name === layerName
                    ? { ...layer, visible: !layer.visible } // Create new object reference
                    : layer
            )
        );

    };

    function layerMarker(layerName){
        console.log("layerMarker : "+layerName);

        let _icon = "icon-bell"
        switch (layerName){
            case "Activities":
            case "Activit":
                _icon="icon-list-heart";
                break;
            case "Ideas":
            case "Idea":
                _icon="icon-lamp-bright";
                break;
            case "Meals":
            case "Meal":
                _icon="icon-fork-knife2";
                break;
            case "Lodging":
                _icon="icon-bed";
                break;
            case "Shopping":
                _icon="icon-bag";
                break;
            case "Supplies":
                _icon="icon-basket";
                break;
            case "Transportation":
                _icon="icon-gas-station";
                break;
            case "Planning":
                _icon="icon-sophisticated";
                break;
            case "Residences":
                _icon="icon-home3";
                break;
            case "Tours":
                _icon="icon-lamp-bright";
                break;
            default:


        }


        const markerContentDiv = document.createElement('div');
        markerContentDiv.innerHTML = `
          <div class="planning-google-map-marker-layer-item">
            <i class="planning-google-map-marker-layer-item-icon ${_icon}" />
            <span class="planning-google-map-marker-layer-item-name">
               ${viewPlaceInfoPlace.name}
            </span>
          </div>
        `;

        const _geometry = viewPlaceInfoPlace.geometry;

        const _markerData = {};
        _markerData.title = viewPlaceInfoPlace.name;
        _markerData.google_place_id = viewPlaceInfoPlace.place_id;

        console.log("props._global_map_ref.current : "+props._global_map_ref.current);

        const _marker = new window.google.maps.marker.AdvancedMarkerView({
            map: props._global_map_ref.current,
            position: _geometry.location,
            content: markerContentDiv,
            title: viewPlaceInfoPlace.name,
        });
        _marker.addListener("click", () => {
            console.log("!!!! clicked on "+_marker.title);
            props._global_map_ref.current.setZoom(15);
            props._global_map_ref.current.setCenter(_marker.position);
            setViewPlaceInfoWindow(true);
        });
        _markerData.marker = _marker;

        console.log("returning markerData : "+_markerData);
        return _markerData;

    }

    const addMarkerToLayer = (layerName, markerData) => {
        // 1. Logic BEFORE the state update
        const allExistingMarkers = mapMarkerLayers.flatMap(l => l.markers);
        const markersAtSameLocation = allExistingMarkers.filter(
            m => m.google_place_id === markerData.google_place_id
        );

        const basePosition = {
            lat: markerData.marker.position.lat,
            lng: markerData.marker.position.lng,
        };

        // Calculate offset
        const offsetPosition = getCircularOffsetPosition(
            basePosition,
            markersAtSameLocation.length,
            markersAtSameLocation.length + 1,
            CATEGORY_RADIUSES[layerName.toUpperCase()] || 0.00005
        );

        // Apply position and ensure it's visible on the map
        markerData.marker.position = offsetPosition;
        markerData.marker.map = props._global_map_ref.current; // Explicitly attach here

        // 2. Pure State Update
        setMapMarkerLayers((prevLayers) => {
            const updatedLayers = [...prevLayers];
            const idx = updatedLayers.findIndex((l) => l.name === layerName);

            if (idx !== -1) {
                // Only add if not already present (prevent duplicates)
                const exists = updatedLayers[idx].markers.some(m => m.google_place_id === markerData.google_place_id);
                if (!exists) {
                    updatedLayers[idx].markers.push(markerData);
                }
            } else {
                updatedLayers.push({
                    name: layerName,
                    type: "markers",
                    visible: true,
                    markers: [markerData],
                });
            }
            return updatedLayers;
        });

        // Increment count to trigger the auto-zoom logic we built earlier
        setMapMarkerLayersCount(prev => prev + 1);
    };

    function removeMapMarkerLayerItem(layerName, _place_id){
        console.log("############### removing marker from layer : "+layerName+" : "+_place_id);

        setMapMarkerLayers((prevLayers) => {
            const updatedLayers = [...prevLayers];
            console.log('Updated Layers:', updatedLayers);

            // Find the index of the layer with the specified name
            const layerIndex = updatedLayers.findIndex((layer) => layer.name === layerName);
            console.log("layerIndex : "+layerIndex);

            if (layerIndex !== -1) {
                // Layer exists, find the index of the marker with the specified Google Place ID
                const markerIndex = updatedLayers[layerIndex].markers.findIndex(
                    (marker) => marker.google_place_id === _place_id
                );
                console.log("markerIndex : "+markerIndex);
                if (markerIndex !== -1) {

                    const markerToRemove = updatedLayers[layerIndex].markers[markerIndex];

                    // Set the map to null to remove it from the Google Map
                    if (markerToRemove.marker) {
                        markerToRemove.marker.map = null; // Physically kills it from the map
                    }

                    // Remove the marker from the layer
                    updatedLayers[layerIndex].markers.splice(markerIndex, 1);

                    // Optionally, remove the layer if it has no markers left
                    if (updatedLayers[layerIndex].markers.length === 0) {
                        updatedLayers.splice(layerIndex, 1);
                    }
                }
            }

            return updatedLayers;
        });
    }

    function removeMapMarkerLayer(layerName){
        console.log("################## removing layer : "+layerName);

        setMapMarkerLayers((prevLayers) => {
            const updatedLayers = [...prevLayers];
            console.log('Updated Layers:', updatedLayers);

            // Find the index of the layer with the specified name
            const layerIndex = updatedLayers.findIndex((layer) => layer.name === layerName);
            console.log("layerIndex : "+layerIndex);

            if (layerIndex !== -1) {
                // Layer exists
                //set map markers to null
                updatedLayers[layerIndex].markers.forEach((markerToRemove) => {
                    if (markerToRemove.marker && markerToRemove.marker.setMap) {
                        markerToRemove.marker.setMap(null);
                    }
                });
                //clear out any markers
                updatedLayers[layerIndex].markers = [];
                //remove the whole Layer
                updatedLayers.splice(layerIndex, 1);
            }

            return updatedLayers;
        });
    }


    const handleButtonOpenMenuClick = (event) => {
        console.log("handleButtonOpenMenuClick");
        if (anchorEl){
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleButtonCloseMenuClick = () => {
        console.log("handleButtonCloseMenuClick");
        setAnchorEl(null); // Close the menu
    };
    const handleButtonCloseClick = () => {
        console.log("handleButtonCloseClick");
        setAnchorEl(null); // Close the menu
        setViewPlaceInfoWindow(false);
    };

    const parseV2Address = (place) => {
        let _address_line = "", _address_city = "", _address_state = "", _address_zip = "", _address_country = "";
        const components = place.addressComponents || [];
        const _country_comp = components.find(c => c.types.includes("country"));
        const _country_code = _country_comp?.shortText || "";

        components.forEach((component) => {
            const types = component.types;
            const val = component.longText;
            if (types.includes("street_number")) _address_line = val;
            else if (types.includes("route")) _address_line = _address_line ? `${_address_line} ${val}` : val;
            else if (types.includes("locality")) _address_city = val;
            else if (types.includes("administrative_area_level_1")) _address_state = (_country_code === "US") ? component.shortText : val;
            else if (types.includes("postal_code")) _address_zip = val;
            else if (types.includes("country")) _address_country = component.shortText;
        });

        if (!_address_line && place.formattedAddress) {
            _address_line = place.formattedAddress.split(',')[0].trim();
        }
        return { _address_line, _address_city, _address_state, _address_zip, _address_country };
    };

    const handleMenuItemClick = (option) => {
        console.log(`Selected option: ${option}`);
        setAnchorEl(null);

        let _action = "";
        let _set_feature = "";
        const parsedAddr = parseV2Address(viewPlaceInfoPlace);

        // Common attendee mapping logic
        const getAttendees = (excludeRole = 'planner') => {
            const all = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees || [];
            return all
                .filter((att) => att.role !== excludeRole && att.role !== 'partial' && att.rsvp !== 'decline')
                .map((att) => ({
                    id: att.id,
                    cost: 0,
                    is_business_expense: false,
                    business_expense_amount: 0,
                }));
        };

        // Shared Location Object Mapper
        const mapToPALocation = (place, parsed) => {
            const loc = new PALocation();
            loc.google_place_id = place.id;
            loc.latitude = typeof place.location?.lat === 'function' ? place.location.lat() : place.location?.lat;
            loc.longitude = typeof place.location?.lng === 'function' ? place.location.lng() : place.location?.lng;
            loc.name = place.displayName?.text || place.displayName;
            loc.formatted_address = place.formattedAddress;
            loc.address = parsed._address_line;
            loc.city = parsed._address_city;
            loc.state = parsed._address_state;
            loc.zip = parsed._address_zip;
            loc.country = parsed._address_country;
            loc.phone = place.internationalPhoneNumber || "";
            loc.types = place.types || [];
            loc.hours = place.regularOpeningHours?.weekdayDescriptions || [];
            loc.website = place.websiteURI || "";
            loc.price_level = place.priceLevel;
            loc.rating = place.rating;
            loc.total_ratings = place.userRatingCount;
            return loc;
        };

        const photos = (viewPlaceInfoPlace.photos || []).map(p =>
            typeof p.getURI === 'function' ? p.getURI({maxWidth: 400, maxHeight: 400}) : ""
        );

        switch (option) {
            case "Activities":
                _action = '/Planner/Activities';
                _set_feature = "Activities";
                const _new_act = new Activity();
                _new_act.title = viewPlaceInfoPlace.displayName?.text || viewPlaceInfoPlace.displayName;
                _new_act.attendees = getAttendees('planner');
                _new_act.Place = viewPlaceInfoPlace;
                _new_act.location = mapToPALocation(viewPlaceInfoPlace, parsedAddr);
                _new_act.photos = photos;

                set_PA_GlobalObject(prev => ({
                    Planning: { ...prev.Planning, activities: [...prev.Planning.activities, _new_act] }
                }));
                if (authenticated && PA_GlobalObject.Planning.status !== 10) {
                    sendSocketMessage({ action: "E_addEventActivity_v2", event_id: PA_GlobalObject.Planning.id, activity: _new_act });
                }
                break;

            case "Ideas":
                _action = '/Planner/Ideas';
                _set_feature = "Ideas";
                const _new_idea = new Idea();
                _new_idea.title = viewPlaceInfoPlace.displayName?.text || viewPlaceInfoPlace.displayName;
                _new_idea.added_by = Account.id;
                _new_idea.Place = viewPlaceInfoPlace;
                _new_idea.location = mapToPALocation(viewPlaceInfoPlace, parsedAddr);
                _new_idea.photos = photos;

                set_PA_GlobalObject(prev => ({
                    Planning: { ...prev.Planning, ideas: [...prev.Planning.ideas, _new_idea] }
                }));
                if (authenticated && PA_GlobalObject.Planning.status !== 10) {
                    sendSocketMessage({ action: "E_addEventIdea_v2", event_id: PA_GlobalObject.Planning.id, idea: _new_idea });
                }
                break;

            case "Meals":
                _action = '/Planner/Meals';
                _set_feature = "Meals";
                const _new_meal = new Meal();
                _new_meal.title = viewPlaceInfoPlace.displayName?.text || viewPlaceInfoPlace.displayName;
                _new_meal.attendees = getAttendees('planner');
                _new_meal.Place = viewPlaceInfoPlace;
                _new_meal.location = mapToPALocation(viewPlaceInfoPlace, parsedAddr);
                _new_meal.photos = photos;

                set_PA_GlobalObject(prev => ({
                    Planning: { ...prev.Planning, meals: [...prev.Planning.meals, _new_meal] }
                }));
                if (authenticated && PA_GlobalObject.Planning.status !== 10) {
                    sendSocketMessage({ action: "E_addEventMeal_v2", event_id: PA_GlobalObject.Planning.id, meal: _new_meal });
                }
                break;

            case "Lodging":
                _action = '/Planner/Lodging';
                _set_feature = "Lodging";
                const _new_lodg = new Lodging();
                _new_lodg.name = viewPlaceInfoPlace.displayName?.text || viewPlaceInfoPlace.displayName;
                _new_lodg.attendees = getAttendees('planner');

                const eventTT = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table;
                if (eventTT?.dates?.length > 0) {
                    _new_lodg.time_table = createTimeTableForLodging(eventTT.dates[0].date, eventTT.dates[eventTT.dates.length - 1].date, eventTT);
                }

                _new_lodg.Place = viewPlaceInfoPlace;
                _new_lodg.location = mapToPALocation(viewPlaceInfoPlace, parsedAddr);
                _new_lodg.photos = photos;

                set_PA_GlobalObject(prev => ({
                    Planning: { ...prev.Planning, lodging: [...prev.Planning.lodging, _new_lodg] }
                }));
                if (authenticated && PA_GlobalObject.Planning.status !== 10) {
                    sendSocketMessage({ action: "E_addEventLodging_v2", event_id: PA_GlobalObject.Planning.id, lodging: _new_lodg });
                }
                break;

            case "Shopping":
                _set_feature = "Shopping";
                addMarkerToLayer('Shopping', layerMarker('Shopping'));
                break;

            case "Tours":
                _set_feature = "Tours";
                addMarkerToLayer('Tours', layerMarker('Tours'));
                break;

            case "Planning":
                const existingItems = props.conciergePlanningItemsFromMap;
                props.setConciergePlanningItemsFromMap([...existingItems, _.cloneDeep(viewPlaceInfoPlace)]);
                addMarkerToLayer('Planning', layerMarker("Planning"));
                break;
        }

        props.setCurrentFeature(_set_feature);
 //       navigate(_action);
        props.setShowEventItemConfig(true);
    };

    const handleMenuItemClickOLD = (option) => {
        // Handle the click on a menu item (e.g., perform an action)
        console.log(`Selected option: ${option}`);
        setAnchorEl(null); // Close the menu

        let _action = "";
        let _set_feature = "";
        switch (option) {
            case "Activities":
                _action = '/Planner/Activities';
                _set_feature = "Activities";
//                addMarkerToLayer('Activities', layerMarker('Activities'));
                break;
            case "Ideas":
                _action = '/Planner/Ideas';
                _set_feature = "Ideas";
//                addMarkerToLayer('Ideas', layerMarker('Ideas'));
                break;
            case "Meals":
                _action = '/Planner/Meals';
                _set_feature = "Meals";
//                addMarkerToLayer('Meals', layerMarker('Meals'));
                break;
            case "Lodging":
                _action = '/Planner/Lodging';
                _set_feature = "Lodging";
//                addMarkerToLayer('Lodging', layerMarker('Lodging'));
                break;
            case "Shopping":
                _set_feature = "Shopping";
                addMarkerToLayer('Shopping', layerMarker('Shopping'));
                break;
            case "Tours":
                _set_feature = "Tours";
                addMarkerToLayer('Tours', layerMarker('Tours'));
                break;
            case "Planning":
                //add to the ConciergePlanning array
                const existingItems = props.conciergePlanningItemsFromMap;
                const newArray = [...existingItems, _.cloneDeep(viewPlaceInfoPlace)];
                props.setConciergePlanningItemsFromMap(newArray);

                //now add a marker to the Marker Layer
                addMarkerToLayer('Planning', layerMarker("Planning"));

                break;
            default:

        }

        if (option === "Lodging"){
            //get details about the Place (viewPlaceInfoPlace)

            //create the new Lodging
            const _new_lodging = new Lodging();

            _new_lodging.name = viewPlaceInfoPlace["name"];
            _new_lodging.phone = viewPlaceInfoPlace["formatted_phone_number"];

            //add any of the Event attendees to the lodging
            const attendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;

            if (attendees.length > 0) {
                _new_lodging.attendees = attendees
                    .filter((att) => att.role !== 'planner') // Exclude attendees with planner: true
                    .map((att) => ({
                        id: att.id,
                        cost: 0,
                        is_business_expense: false,
                        business_expense_amount_authorized: 0,
                        business_expense_amount_authorized_by: "",
                        business_expense_amount_authorized_timestamp: 0,
                        business_expense_amount: 0,
                        business_expense_paid: 0,
                        business_expense_reference_id: "",
                    }));
            }


            //for this we look to see if the Event has dates assigned and if so we
            //create a matching time_table for the lodging
            const eventTimeTable = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table;
            if (eventTimeTable?.dates?.length > 0) {
                _new_lodging.time_table = createTimeTableForLodging(
                    eventTimeTable.dates[0].date,
                    eventTimeTable.dates[eventTimeTable.dates.length - 1].date,
                    eventTimeTable);
            }


            //set the Place object from Google
            _new_lodging.Place = viewPlaceInfoPlace;

            //add the lodging location
            const _place_location = viewPlaceInfoPlace["geometry"];

            const _lodging_location = new PALocation();
            _lodging_location.google_place_id = viewPlaceInfoPlace["place_id"];
            _lodging_location.latitude = _place_location.location.lat();
            _lodging_location.longitude = _place_location.location.lng();


            let _address_line = "";
            let _address_city = "";
            let _address_state = "";
            let _address_zip = "";
            let _address_country = "";

            let _route_exists = false;
            let _country_code = "";
            if (Array.isArray(viewPlaceInfoPlace.address_components)) {

                for (const component of viewPlaceInfoPlace.address_components) {
                    if (component.types.includes("route")) {
                        _route_exists = true;
                    } else if (component.types.includes("country")) {
                        _country_code = component.short_name;
                    }
                }

                viewPlaceInfoPlace.address_components.forEach((component) => {
                    if (component.types.includes("street_number")){
                        _address_line = component.long_name;
                    } else if (component.types.includes("route")){
                        _address_line += " "+component.long_name;
                    } else if (!_route_exists && component.types.includes("administrative_area_level_2")){
                        _address_line += " "+component.long_name;
                    } else if (component.types.includes("locality") || component.types.includes("postal_town")){
                        _address_city = component.long_name;
                    } else if (component.types.includes("administrative_area_level_1") && _country_code === "US"){
                        _address_state = component.short_name;
                    } else if (component.types.includes("postal_code")){
                        _address_zip = component.long_name;
                    } else if (component.types.includes("country")){
                        if (_country_code !== "US"){
                            _address_state = component.long_name;
                        }
                        _address_country = component.short_name;
                    }
                });

            } else {
                console.log("address_components is not iterable");
                /*
                    so lets see if we can break apart the formatted_address
                 */

                const components = viewPlaceInfoPlace.formatted_address.split(',').map(component => component.trim());

                // Initialize variables
                let address = '';
                let city = '';
                let state = '';
                let zip = '';
                let country = '';

                // Assuming the country is always the last component
                if (components.length > 0) {
                    _address_country = components.pop();
                }

                // Process remaining components
                if (components.length > 0) {
                    _address_line = components.shift();
                }

                if (components.length > 0) {
                    _address_city = components.shift();
                }

                if (components.length > 0) {
                    _address_state = components.shift();
                }

                // If the state contains a zip code, split them
                const stateZipMatch = _address_state.match(/^(.+?)\s*(\d{5})?$/);
                if (stateZipMatch) {
                    _address_state = stateZipMatch[1];
                    _address_zip = stateZipMatch[2] || '';
                }


            }


            if (_address_line === ""){
                //try getting it from the formatted address
                try {
                    const _f_address_pieces = viewPlaceInfoPlace.formatted_address.split(',');
                    if (_f_address_pieces[0] !== ""){
                        _address_line = _f_address_pieces[0].trim();
                    }
                } catch (e){}
            }

            console.log("the _address_line : "+_address_line);
            console.log("the _address_city : "+_address_city);
            console.log("the _address_state : "+_address_state);
            console.log("the _address_zip: "+_address_zip);
            console.log("the _address_country: "+_address_country);


            _lodging_location.name =  viewPlaceInfoPlace["name"];
            _lodging_location.formatted_address = viewPlaceInfoPlace["formatted_address"];
            _lodging_location.address = _address_line;
            _lodging_location.city = _address_city;
            _lodging_location.state = _address_state;
            _lodging_location.zip = _address_zip;
            _lodging_location.country = _address_country;

            _new_lodging.location = _lodging_location;

            const _photos_array = [];
            if (viewPlaceInfoPlace.photos && Array.isArray(viewPlaceInfoPlace.photos)) {
                for (const _photo of viewPlaceInfoPlace.photos) {
                    _photos_array.push(_photo.getURI({maxWidth: 175, maxHeight: 175}));
                }
            }
            _new_lodging.photos = _photos_array;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    lodging: [...prev.Planning.lodging, _new_lodging],
                },
            }));

        } else if (option === "Activities"){
            setAnchorEl(null); // Close the menu

            //get details about the Place (viewPlaceInfoPlace)
            console.log("the Activities viewPlaceInfoPlace : ", viewPlaceInfoPlace);

            //create the new Activity
            const _new_activity = new Activity();
            _new_activity.title = viewPlaceInfoPlace["name"]
            _new_activity.phone = viewPlaceInfoPlace["formatted_phone_number"]

            //add any of the Event attendees to the activity
            const attendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;

            if (attendees.length > 0) {
                _new_activity.attendees = attendees
                    .filter((att) => att.role !== 'planner') // Exclude attendees with planner: true
                    .map((att) => ({
                        id: att.id,
                        cost: 0,
                        is_business_expense: false,
                        business_expense_amount_authorized: 0,
                        business_expense_amount_authorized_by: "",
                        business_expense_amount_authorized_timestamp: 0,
                        business_expense_amount: 0,
                        business_expense_paid: 0,
                        business_expense_reference_id: "",
                    }));
            }

            //set the Place object from Google
            _new_activity.Place = viewPlaceInfoPlace;

            //add the activity location
            const _place_location = viewPlaceInfoPlace["geometry"];

            const _activity_location = new PALocation();
            _activity_location.google_place_id = viewPlaceInfoPlace["place_id"];
            _activity_location.latitude = _place_location.location.lat();
            _activity_location.longitude = _place_location.location.lng();


            let _address_line = "";
            let _address_city = "";
            let _address_state = "";
            let _address_zip = "";
            let _address_country = "";

            let _route_exists = false;
            let _country_code = "";
            if (Array.isArray(viewPlaceInfoPlace.address_components)) {

                for (const component of viewPlaceInfoPlace.address_components){
                    if (component.types.includes("route")) {
                        _route_exists = true;
                    } else if (component.types.includes("country")){
                        _country_code = component.short_name;
                    }
                }

                viewPlaceInfoPlace.address_components.forEach((component) => {
                    if (component.types.includes("street_number")){
                        _address_line = component.long_name;
                    } else if (component.types.includes("route")){
                        _address_line += " "+component.long_name;
                    } else if (!_route_exists && component.types.includes("administrative_area_level_2")){
                        _address_line += " "+component.long_name;
                    } else if (component.types.includes("locality") || component.types.includes("postal_town")){
                        _address_city = component.long_name;
                    } else if (component.types.includes("administrative_area_level_1") && _country_code === "US"){
                        _address_state = component.short_name;
                    } else if (component.types.includes("postal_code")){
                        _address_zip = component.long_name;
                    } else if (component.types.includes("country")){
                        if (_country_code !== "US"){
                            _address_state = component.long_name;
                        }
                        _address_country = component.short_name;
                    }
                });
            } else {
                console.log("address_components is not iterable");
                /*
                    so lets see if we can break apart the formatted_address
                 */

                const components = viewPlaceInfoPlace.formatted_address.split(',').map(component => component.trim());

                // Initialize variables
                let address = '';
                let city = '';
                let state = '';
                let zip = '';
                let country = '';

                // Assuming the country is always the last component
                if (components.length > 0) {
                    _address_country = components.pop();
                }

                // Process remaining components
                if (components.length > 0) {
                    _address_line = components.shift();
                }

                if (components.length > 0) {
                    _address_city = components.shift();
                }

                if (components.length > 0) {
                    _address_state = components.shift();
                }

                // If the state contains a zip code, split them
                const stateZipMatch = _address_state.match(/^(.+?)\s*(\d{5})?$/);
                if (stateZipMatch) {
                    _address_state = stateZipMatch[1];
                    _address_zip = stateZipMatch[2] || '';
                }


            }

            if (_address_line === ""){
                //try getting it from the formatted address
                try {
                    const _f_address_pieces = viewPlaceInfoPlace.formatted_address.split(',');
                    if (_f_address_pieces[0] !== ""){
                        _address_line = _f_address_pieces[0].trim();
                    }
                } catch (e){}
            }

            console.log("the _address_line : "+_address_line);
            console.log("the _address_city : "+_address_city);
            console.log("the _address_state : "+_address_state);
            console.log("the _address_zip: "+_address_zip);
            console.log("the _address_country: "+_address_country);


            _activity_location.name =  viewPlaceInfoPlace["name"];
            _activity_location.formatted_address = viewPlaceInfoPlace["formatted_address"];
            _activity_location.address = _address_line;
            _activity_location.city = _address_city;
            _activity_location.state = _address_state;
            _activity_location.zip = _address_zip;
            _activity_location.country = _address_country;

            _new_activity.location = _activity_location;

            const _photos_array = [];
            if (viewPlaceInfoPlace.photos && Array.isArray(viewPlaceInfoPlace.photos)) {
                for (const _photo of viewPlaceInfoPlace.photos) {
                    _photos_array.push(_photo.getURI({maxWidth: 175, maxHeight: 175}));
                }
            }
            _new_activity.photos = _photos_array;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    activities: [...prev.Planning.activities, _new_activity],
                },
            }));

        } else if (option === "Meals"){
            setAnchorEl(null); // Close the menu

            //get details about the Place (viewPlaceInfoPlace)
//            console.log("the Meal viewPlaceInfoPlace : "+JSON.stringify(viewPlaceInfoPlace, null, '\t'));

            //create the new Meal
            const _new_meal = new Meal();

            _new_meal.phone = viewPlaceInfoPlace["formatted_phone_number"]

            //add any of the Event attendees to the meal
            const attendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;

            if (attendees.length > 0) {
                _new_meal.attendees = attendees
                    .filter((att) => att.role !== 'planner') // Exclude attendees with planner: true
                    .map((att) => ({
                        id: att.id,
                        cost: 0,
                        is_business_expense: false,
                        business_expense_amount_authorized: 0,
                        business_expense_amount_authorized_by: "",
                        business_expense_amount_authorized_timestamp: 0,
                        business_expense_amount: 0,
                        business_expense_paid: 0,
                        business_expense_reference_id: "",
                    }));
            }

            //set the Place object from Google
            _new_meal.Place = viewPlaceInfoPlace;

            //add the meal location
            const _place_location = viewPlaceInfoPlace["geometry"];

            const _meal_location = new PALocation();
            _meal_location.google_place_id = viewPlaceInfoPlace["place_id"];
            _meal_location.latitude = _place_location.location.lat();
            _meal_location.longitude = _place_location.location.lng();


            let _address_line = "";
            let _address_city = "";
            let _address_state = "";
            let _address_zip = "";
            let _address_country = "";

            let _route_exists = false;
            let _country_code = "";
            if (Array.isArray(viewPlaceInfoPlace?.address_components)) {
                for (const component of viewPlaceInfoPlace.address_components) {
                    if (component.types.includes("route")) {
                        _route_exists = true;
                    } else if (component.types.includes("country")) {
                        _country_code = component.short_name;
                    }
                }
            } else {
                console.error('address_components is not iterable or not an array');
            }

            if (Array.isArray(viewPlaceInfoPlace?.address_components)) {
                viewPlaceInfoPlace.address_components.forEach((component) => {
                    if (component.types.includes("street_number")){
                        _address_line = component.long_name;
                    } else if (component.types.includes("route")){
                        _address_line += " "+component.long_name;
                    } else if (!_route_exists && component.types.includes("administrative_area_level_2")){
                        _address_line += " "+component.long_name;
                    } else if (component.types.includes("locality") || component.types.includes("postal_town")){
                        _address_city = component.long_name;
                    } else if (component.types.includes("administrative_area_level_1") && _country_code === "US"){
                        _address_state = component.short_name;
                    } else if (component.types.includes("postal_code")){
                        _address_zip = component.long_name;
                    } else if (component.types.includes("country")){
                        if (_country_code !== "US"){
                            _address_state = component.long_name;
                        }
                        _address_country = component.short_name;
                    }
                });
            }

            if (_address_line === ""){
                //try getting it from the formatted address
                try {
                    const _f_address_pieces = viewPlaceInfoPlace.formatted_address.split(',');
                    if (_f_address_pieces[0] !== ""){
                        _address_line = _f_address_pieces[0].trim();
                    }
                } catch (e){}
            }

            console.log("the _address_line : "+_address_line);
            console.log("the _address_city : "+_address_city);
            console.log("the _address_state : "+_address_state);
            console.log("the _address_zip: "+_address_zip);
            console.log("the _address_country: "+_address_country);


            _meal_location.name =  viewPlaceInfoPlace["name"];
            _meal_location.formatted_address = viewPlaceInfoPlace["formatted_address"];
            _meal_location.address = _address_line;
            _meal_location.city = _address_city;
            _meal_location.state = _address_state;
            _meal_location.zip = _address_zip;
            _meal_location.country = _address_country;

            _new_meal.location = _meal_location;

            _new_meal.title = viewPlaceInfoPlace["name"];

            const _photos_array = [];
            if (viewPlaceInfoPlace.photos && Array.isArray(viewPlaceInfoPlace.photos)) {
                for (const _photo of viewPlaceInfoPlace.photos) {
                    _photos_array.push(_photo.getURI({maxWidth: 175, maxHeight: 175}));
                }
            }
            _new_meal.photos = _photos_array;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    meals: [...prev.Planning.meals, _new_meal],
                },
            }));

        } else if (option === "Ideas"){
            setAnchorEl(null); // Close the menu

            //get details about the Place (viewPlaceInfoPlace)
            console.log("the Idea viewPlaceInfoPlace : "+JSON.stringify(viewPlaceInfoPlace, null, '\t'));

            //create the new Idea
            const _new_idea = new Idea();
            _new_idea.added_by = Account.id;

            _new_idea.title = viewPlaceInfoPlace["name"]
            _new_idea.phone = viewPlaceInfoPlace["formatted_phone_number"]

            //set the Place object from Google
            _new_idea.Place = viewPlaceInfoPlace;

            //add the activity location
            const _place_location = viewPlaceInfoPlace["geometry"];

            const _idea_location = new PALocation();
            _idea_location.google_place_id = viewPlaceInfoPlace["place_id"];
            _idea_location.latitude = _place_location.location.lat();
            _idea_location.longitude = _place_location.location.lng();


            let _address_line = "";
            let _address_city = "";
            let _address_state = "";
            let _address_zip = "";
            let _address_country = "";

            let _route_exists = false;
            let _country_code = "";
            for (const component of viewPlaceInfoPlace.address_components){
                if (component.types.includes("route")) {
                    _route_exists = true;
                } else if (component.types.includes("country")){
                    _country_code = component.short_name;
                }
            }

            viewPlaceInfoPlace.address_components.forEach((component) => {
                if (component.types.includes("street_number")){
                    _address_line = component.long_name;
                } else if (component.types.includes("route")){
                    _address_line += " "+component.long_name;
                } else if (!_route_exists && component.types.includes("administrative_area_level_2")){
                    _address_line += " "+component.long_name;
                } else if (component.types.includes("locality") || component.types.includes("postal_town")){
                    _address_city = component.long_name;
                } else if (component.types.includes("administrative_area_level_1") && _country_code === "US"){
                    _address_state = component.short_name;
                } else if (component.types.includes("postal_code")){
                    _address_zip = component.long_name;
                } else if (component.types.includes("country")){
                    if (_country_code !== "US"){
                        _address_state = component.long_name;
                    }
                    _address_country = component.short_name;
                }
            });

            if (_address_line === ""){
                //try getting it from the formatted address
                try {
                    const _f_address_pieces = viewPlaceInfoPlace.formatted_address.split(',');
                    if (_f_address_pieces[0] !== ""){
                        _address_line = _f_address_pieces[0].trim();
                    }
                } catch (e){}
            }

            console.log("the _address_line : "+_address_line);
            console.log("the _address_city : "+_address_city);
            console.log("the _address_state : "+_address_state);
            console.log("the _address_zip: "+_address_zip);
            console.log("the _address_country: "+_address_country);


            _idea_location.name =  viewPlaceInfoPlace["name"];
            _idea_location.formatted_address = viewPlaceInfoPlace["formatted_address"];
            _idea_location.address = _address_line;
            _idea_location.city = _address_city;
            _idea_location.state = _address_state;
            _idea_location.zip = _address_zip;
            _idea_location.country = _address_country;

            _new_idea.location = _idea_location;

            const _photos_array = [];
            if (viewPlaceInfoPlace.photos && Array.isArray(viewPlaceInfoPlace.photos)) {
                for (const _photo of viewPlaceInfoPlace.photos) {
                    _photos_array.push(_photo.getURI({maxWidth: 175, maxHeight: 175}));
                }
            }
            _new_idea.photos = _photos_array;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    ideas: [...prev.Planning.ideas, _new_idea],
                },
            }));

        }

        props.setCurrentFeature(_set_feature);

        navigate(_action);
        props.setShowEventItemConfig(true);


    };

    function getRandomShadeOfBlack() {
        console.log("getRandomShadeOfBlack");
        // Generate a random value for saturation and lightness
        const randomSaturation = Math.floor(Math.random() * 20) + 80; // Random value between 80 and 100
        const randomLightness = Math.floor(Math.random() * 20) + 10; // Random value between 10 and 30

        // Convert HSL values to a CSS color string
        return `hsl(0, ${randomSaturation}%, ${randomLightness}%)`;
    }

    const [column1Width, setColumn1Width] = useState(0);
    const column1Ref = useRef(null);
    useEffect(() => {

        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                // Identify the column being observed and update the corresponding state
                if (entry.target === column1Ref.current) {
                    setColumn1Width(entry.contentRect.width);
                }
            }
        });

        if (column1Ref.current) observer.observe(column1Ref.current);

        return () => {
            if (column1Ref.current) observer.unobserve(column1Ref.current);
        };

    }, []);

    const adjustGlobalMapMarkersBoundsZoom1 = () => {
        const currentMap = props._global_map_ref.current;
        if (!currentMap) return;

        const bounds = new window.google.maps.LatLngBounds();
        let visibleMarkersCount = 0;

        // Helper to validate and extend bounds
        const extendBoundsIfValid = (pos) => {
            // Ensure position exists and isn't (0,0) which causes the "space" zoom
            if (pos && typeof pos.lat === 'function' && pos.lat() !== 0 && pos.lng() !== 0) {
                bounds.extend(pos);
                visibleMarkersCount++;
            } else if (pos && typeof pos.lat === 'number' && pos.lat !== 0 && pos.lng !== 0) {
                bounds.extend(pos);
                visibleMarkersCount++;
            }
        };

        console.log("mapMarkerLayers : ", mapMarkerLayers);

        // 1. Scan Planning Layers (Lodging, Activities, etc.)
        mapMarkerLayers.forEach(layer => {
            layer.markers.forEach(markerData => {
                console.log("markerData : ", markerData);
                console.log("markerData.marker : ", markerData.marker);
                console.log("markerData.marker.map : ", markerData.marker.map);
                console.log("markerData.marker.map equal currentMap: ", markerData.marker.map === currentMap);
                // Only include markers currently active on the map
                if (markerData.marker && markerData.marker.map === currentMap) {
                    extendBoundsIfValid(markerData.marker.position);
                }
            });
        });

        console.log("visibleMarkersCount : ", visibleMarkersCount);

        // Only adjust if there are markers to show
        if (visibleMarkersCount > 0) {
            // Fit the map to the markers found
            currentMap.fitBounds(bounds, {
                top: 150,
                right: 150,
                bottom: 150,
                left: 150
            });

            // Optional: Prevent the map from zooming in TOO far if there's only 1 marker
            if (visibleMarkersCount === 1) {
                const listener = window.google.maps.event.addListener(currentMap, 'idle', () => {
                    if (currentMap.getZoom() > 15) currentMap.setZoom(15);
                    window.google.maps.event.removeListener(listener);
                });
            }
        } else {
            // Fallback: If nothing is visible, zoom out to a default view or do nothing
            console.log("No visible markers to zoom to.");
            currentMap.setCenter({ lat: 35.5951, lng: -82.5515 }); // Default NYC
            currentMap.setZoom(10);
        }

    };

    return (

        <div style={{ position:'relative'}}>

            {/* add the layers icon */}
            <div className="planning-map-mobile-area-layers-icon-holder">
                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center'}}
                >
                    <Badge
                        badgeContent={mapMarkerLayersCount}
                        color="badge"
                    >
                        <IconButton
                            type="button"
                            sx={{
                                p: '10px',
                            }}
                            aria-label="map layers for Markers"
                            onClick={handleButtonOpenLayersMenuClick}
                        >
                            <i className="icon-layers" title="Marker Layers"/>
                        </IconButton>
                    </Badge>
                    <Menu
                        id="split-button-menu"
                        anchorEl={anchorLayersEl}
                        open={Boolean(anchorLayersEl)}
                        onClose={handleButtonLayersMenuClose}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <MenuList dense sx={{ cursor: 'default', minWidth: '220px' }}>
                            {mapMarkerLayers.length > 0 ? (
                                mapMarkerLayers.map((layer, index) => {
                                    const isExpanded = !!expandedLayers[layer.name];
                                    const markersToShow = isExpanded
                                        ? layer.markers
                                        : layer.markers.slice(0, 5);
                                    const hasMore = layer.markers.length > 5;

                                    return (
                                        <div key={`layer-${index}`}>
                                            {/* Layer Header */}
                                            <ListItem
                                                sx={{
                                                    cursor: 'default',
                                                    padding: '4px 8px',
                                                    alignItems: 'center',
                                                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                                                    display: 'flex'
                                                }}
                                                disableRipple
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 'auto',
                                                        fontSize: '14px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '12px'
                                                    }}
                                                >
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                                        {layer.markers.length}
                                                    </Typography>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ variant: 'body2', sx: { fontWeight: 500 } }}
                                                >
                                                    {(() => {
                                                        const knownCategories = ['Meal', 'Lodging', 'Activit', 'Idea', 'Shopping', 'Supplies', 'Transportation'];
                                                        const name = layer.name;
                                                        const count = layer.markers.length;

                                                        // 1. If it's NOT a known category, it's a search query: return as-is
                                                        if (!knownCategories.includes(name)) {
                                                            return name;
                                                        }

                                                        // 2. Otherwise, apply your dynamic pluralization logic
                                                        if (name === 'Activit') {
                                                            return count === 1 ? 'Activity' : 'Activities';
                                                        }
                                                        if (name === 'Shopping') {
                                                            return count === 1 ? 'Shopping' : 'Shopping';
                                                        }
                                                        if (name === 'Supplies') {
                                                            return count === 1 ? 'Supplies' : 'Supplies';
                                                        }
                                                        if (name === 'Transportation') {
                                                            return count === 1 ? 'Transit' : 'Transit';
                                                        }

                                                        // Default pluralization for Meal -> Meals, etc.
                                                        return count === 1 ? name : `${name}s`;
                                                    })()}
                                                </ListItemText>

                                                <Checkbox
                                                    size="small"
                                                    edge="end"
                                                    checked={layer.visible}
                                                    onChange={() => toggleLayerVisibility(layer.name)}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                            </ListItem>

                                            {/* Marker List Section */}
                                            <MenuList dense sx={{ py: 0 }}>
                                                {markersToShow.map((markerData, markerIndex) => (
                                                    <ListItem
                                                        key={`${index}-${markerIndex}`}
                                                        sx={{
                                                            cursor: 'pointer',
                                                            padding: '0 8px',
                                                            pl: 4, // Indent markers
                                                            minHeight: '24px',
                                                            transition: 'background-color 0.2s',
                                                            '&:hover': {
                                                                backgroundColor: '#f0f0f0'
                                                            }
                                                        }}
                                                        disableRipple
                                                        // --- HOVER LOGIC START ---
                                                        onMouseEnter={() => {
                                                            const marker = markerData.marker;
                                                            if (marker && marker.content) {
                                                                // PinElement is essentially the 'content' of the marker
                                                                // We use scale (1 is default) and background
                                                                marker.zIndex = 1000; // Bring to front
                                                                marker.content.style.transform = 'scale(1.3)';
                                                                marker.content.style.transition = 'transform 0.2s ease-in-out';

                                                                // If you are using PinElement, access the background property
                                                                // Note: marker.content is the DOM element of the PinElement
                                                                const pinElement = marker.content.closest('gmp-pin') || marker.content;
                                                                pinElement.background = "#428ce2"; // Bright Yellow
                                                            }
                                                        }}
                                                        onMouseLeave={() => {
                                                            const marker = markerData.marker;
                                                            if (marker && marker.content) {
                                                                marker.zIndex = null; // Reset depth
                                                                marker.content.style.transform = 'scale(1)';

                                                                const pinElement = marker.content.closest('gmp-pin') || marker.content;
                                                                // Return to original orange color from your addMarker logic
                                                                pinElement.background = "#f09637";
                                                            }
                                                        }}
                                                        // --- HOVER LOGIC END ---
                                                    >
                                                        <ListItemText>
                                                            <Typography variant="caption" noWrap sx={{ display: 'block', color: 'text.secondary' }}>
                                                                {/* Handles both string titles and Google Place object titles */}
                                                                {typeof markerData.title === 'object' ? markerData.title?.text : markerData.title}
                                                            </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                ))}

                                                {/* Show More / Less Toggle */}
                                                {hasMore && (
                                                    <MenuItem
                                                        onClick={() => setExpandedLayers(prev => ({
                                                            ...prev,
                                                            [layer.name]: !isExpanded
                                                        }))}
                                                        sx={{
                                                            justifyContent: 'center',
                                                            py: 0.5,
                                                            minHeight: 'auto',
                                                            '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
                                                        }}
                                                    >
                                                        <Typography variant="caption" color="primary" sx={{ fontWeight: 'bold', fontSize: '10px' }}>
                                                            {isExpanded
                                                                ? "↑ SHOW LESS"
                                                                : `+ VIEW ${layer.markers.length - 5} MORE`}
                                                        </Typography>
                                                    </MenuItem>
                                                )}
                                            </MenuList>
                                        </div>
                                    );
                                })
                            ) : (
                                <MenuItem disabled>
                                    <ListItemText>No Layers</ListItemText>
                                </MenuItem>
                            )}
                        </MenuList>
                    </Menu>
                </Paper>
            </div>

            {/* add the map */}
            <div
                ref={column1Ref}
                className="planning-map-mobile-area-google-map-holder"
                id="global_google_map_holder"
                style={{ width: '100%', height: 'calc(100vh - 265px)' }}
            />

            {/* add the place info panel */}
            <div
                className="planning-map-mobile-area-place-info-container"
                style={{display: viewPlaceInfoWindow ? 'block' : 'none'}}
            >
                <Paper
                    sx={{ p: '10px', display: 'flex', alignItems: 'center' }}
                >
                    {
                        viewPlaceInfoPlace && viewPlaceInfoWindow ? (
                            <div className="planning-map-mobile-area-place-info-holder" >
                                {/* add the header */}
                                <div className="planning-map-area-place-info-name"><strong>{viewPlaceInfoPlace.name}</strong></div>
                                {/* add the description */}

                                {/* add the Chip to add to a particular area */}
                                <div className="planning-map-area-place-info-button-holder">
                                    <Chip
                                        sx={cancelChipStyle}
                                        label="Close"
                                        size="small"
                                        onClick={handleButtonCloseClick}
                                    />
                                    <Chip
                                        sx={updateChipStyle}
                                        label="Add"
                                        size="small"
                                        onClick={handleButtonOpenMenuClick}
                                    />
                                    <Menu
                                        id="split-button-menu"
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleButtonCloseMenuClick}

                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}

                                    >
                                        <MenuList dense >
                                            <MenuItem onClick={() => handleMenuItemClick('Activities')}>Add to Activities</MenuItem>
                                            <MenuItem onClick={() => handleMenuItemClick('Ideas')}>Add to Ideas</MenuItem>
                                            <MenuItem onClick={() => handleMenuItemClick('Lodging')}>Add to Lodging</MenuItem>
                                            <MenuItem onClick={() => handleMenuItemClick('Meals')}>Add to Meals</MenuItem>
                                        </MenuList>

                                    </Menu>
                                </div>

                                {/* add the address */}
                                <div className="planning-map-area-place-info-address">{viewPlaceInfoPlace.formatted_address}</div>

                                {/* add any images */}
                                {
                                    viewPlaceInfoPlace.photos && viewPlaceInfoPlace.photos.length > 0 ? (
                                        <div style={{ width: '100%', display: 'flex', overflowX: 'scroll' }}>
                                            {
                                                viewPlaceInfoPlace['photos'].map((_photo, index) => (
                                                    <CardMedia
                                                        key={index}
                                                        component="img"
                                                        sx={{marginRight: '10px', marginBottom: '5px', borderRadius: '5px', maxHeight:'150px'}}
                                                        alt={`Attribution ${index + 1}`}
                                                        image={_photo.getURI({maxWidth: 150, maxHeight: 150})} // Use the attribution as the image source
                                                    />
                                                ))
                                            }
                                        </div>
                                    ):(
                                        <></>
                                    )
                                }

                                {/* add the reviews */}
                                <div className="planning-map-area-place-info-rating-holder">
                                    {
                                        viewPlaceInfoPlace.rating ? (
                                            <Rating
                                                sx={{flex: '1'}}
                                                name="read-only"
                                                value={viewPlaceInfoPlace.rating}
                                                precision={0.1}
                                                readOnly />
                                        ) : null
                                    }
                                    {
                                        viewPlaceInfoPlace.userRatingCount ? (
                                            <Typography
                                                sx={{
                                                    fontSize:'12px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                                component="legend"
                                            >
                                                {viewPlaceInfoPlace.userRatingCount} review{viewPlaceInfoPlace.userRatingCount===1?'':'s'}
                                            </Typography>
                                        ) : null
                                    }
                                </div>
                                {/* add the price level */}

                                {/* add the types chips */}
                                {
                                    viewPlaceInfoPlace.types && viewPlaceInfoPlace.types.length > 0 ? (
                                        <div className="planning-map-area-place-info-type-holder">
                                            {viewPlaceInfoPlace.types.map((item, index) => (
                                                item !== 'point_of_interest' && item !== 'establishment' ? (
                                                    <Chip
                                                        key={index}
                                                        label={item}
                                                        size='small'
                                                    />
                                                ) : (
                                                    <div key={index}></div>
                                                )

                                            ))
                                            }
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                                {/* add the hours */}


                                {/* add the website */}
                                {
                                    viewPlaceInfoPlace.websiteURI && viewPlaceInfoPlace.websiteURI !== "" ? (
                                        <span
                                            className="planning-map-area-place-info-website-holder"
                                            onClick={() => {window.open(viewPlaceInfoPlace.websiteURI, "_blank")}}
                                        >
                                            Website
                                        </span>
                                    ) : (
                                        <></>
                                    )
                                }
                            </div>
                        ) : (
                            <></>
                        )

                    }
                </Paper>
            </div>

        </div>
    )

}

export default GoogleMapMobile;



